export const UPLOAD_CLIENT_DOCUMENT = 'SAGA/UPLOAD_CLIENT_DOCUMENT';

export const uploadClientDocument = (payload) => {
  return {
    type: UPLOAD_CLIENT_DOCUMENT,
    payload,
  };
};
